import axios, { AxiosInstance } from 'axios';
import { config } from 'config';
import { inject, injectable } from 'inversify';
import { observable, reaction } from 'mobx';
import { STORAGE_TOKEN_NAME } from '../constants/base.constants';
import { ILocalStorageAdapter, LocalStorageSymbol } from '../stores/adapters/ILocalStorageAdapter';

@injectable()
export class HttpClient {

    @observable token;
    isConnected;

    client: AxiosInstance = axios.create({
        baseURL: config.apiUrl
    });

    constructor(
        @inject(LocalStorageSymbol) private localStorageAdapter: ILocalStorageAdapter
    ) {
        this.client.defaults.timeout = config.connectionTimeout;
        this.client.defaults.headers.common['X-Api-Key'] = config.apiKey;

        this.client.interceptors.response.use(response => response, error => {
            if (error.response && 401 === error.response.status) {
                this.resetToken();
                return Promise.reject(error);
            }

            return Promise.reject(error);
        });

        this.refreshToken();
    }

    async resetToken() {
        await this.localStorageAdapter.remove(STORAGE_TOKEN_NAME);
        this.token = null;
        return this.refreshToken();
    }

    async refreshToken() {
        const token = await this.localStorageAdapter.read(STORAGE_TOKEN_NAME);

        if (token) {
            this.client.defaults.headers.common['X-IG-Auth-Token'] = token;
        } else {
            delete this.client.defaults.headers.common['X-IG-Auth-Token'];
        }
    }

}
